import { gql } from "@apollo/client/core";

export const DOCUMENT_CLIENT_QUERY = gql`
  query ClientDocumentQuery($lawcaseId: ID!, $documentId: ID!) {
    lawcaseClient(lawcaseId: $lawcaseId) {
      id
      title
      description
      document(documentId: $documentId) {
        id
        title
        hasRead
        description
        filePath
        fileType
        folder {
          id
          name
        }
      }
    }
  }
`;

export const MARK_AS_READ_DOCUMENT_MUTATION = gql`
  mutation ($lawcaseId: ID!, $documentId: ID!) {
    markAsReadDocument(lawcaseId: $lawcaseId, documentId: $documentId) {
      id
      hasRead
    }
  }
`;

export const AUDIT_READ_DOCUMENT_MUTATION = gql`
  mutation ($lawcaseId: ID!, $documentId: ID!) {
    auditReadDocument(lawcaseId: $lawcaseId, documentId: $documentId) {
      id
      type
      insertedAt
    }
  }
`;
